import React, { useCallback, useEffect, useState } from "react";
import {
  Alert,
  Box,
  CircularProgress,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";
import { useSnackbar } from "notistack";
import api from "../api/axios";

const DebtorList = ({ refreshKey = 0 }) => {
  const { enqueueSnackbar } = useSnackbar();

  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState("");

  const fetchRows = useCallback(
    async (searchValue = "") => {
      try {
        setLoading(true);

        const res = await api.get("/debtors", {
          params: {
            search: searchValue || undefined,
          },
        });

        setRows(Array.isArray(res.data) ? res.data : []);
      } catch (err) {
        enqueueSnackbar("Échec du chargement des débiteurs", {
          variant: "error",
        });
        setRows([]);
      } finally {
        setLoading(false);
      }
    },
    [enqueueSnackbar]
  );

  useEffect(() => {
    fetchRows(search);
  }, [fetchRows, refreshKey, search]);
  
  const handleSearch = (e) => {
    const value = e.target.value;
    setSearch(value);
  };

  return (
    <Paper sx={{ p: 3, borderRadius: 3 }}>
      <Typography variant="h6" sx={{ fontWeight: 800, mb: 2 }}>
        Liste des débiteurs
      </Typography>

      <TextField
        fullWidth
        label="Rechercher un débiteur"
        value={search}
        onChange={handleSearch}
        sx={{ mb: 2 }}
      />

      {loading ? (
        <Box sx={{ display: "flex", justifyContent: "center", py: 4 }}>
          <CircularProgress />
        </Box>
      ) : rows.length === 0 ? (
        <Alert severity="info">Aucun débiteur enregistré.</Alert>
      ) : (
        <TableContainer>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>Nom</TableCell>
                <TableCell>Téléphone</TableCell>
                <TableCell>E-mail</TableCell>
                <TableCell>Type pièce</TableCell>
                <TableCell>N° pièce</TableCell>
                <TableCell>Adresse</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {rows.map((row) => (
                <TableRow key={row.id} hover>
                  <TableCell>{row.full_name || "-"}</TableCell>
                  <TableCell>{row.phone || "-"}</TableCell>
                  <TableCell>{row.email || "-"}</TableCell>
                  <TableCell>{row.id_type || "-"}</TableCell>
                  <TableCell>{row.id_number || "-"}</TableCell>
                  <TableCell>{row.address || "-"}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </Paper>
  );
};

export default DebtorList;